import { render, staticRenderFns } from "./riskReporting.vue?vue&type=template&id=2561ce2e&scoped=true&"
import script from "./riskReporting.vue?vue&type=script&lang=ts&"
export * from "./riskReporting.vue?vue&type=script&lang=ts&"
import style0 from "./riskReporting.vue?vue&type=style&index=0&id=2561ce2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561ce2e",
  null
  
)

export default component.exports